import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';

type RatesProps = {
  facility: Facility;
};

const Rates: React.FC<RatesProps> = ({ facility }) => {
  const ratePlanName = facility.ratePlan?.name ?? 'N/A';
  const serviceRatePlanName = facility.serviceRatePlans?.[0]?.ratePlan?.name ?? 'N/A';

  return (
    <Card>
      <Card.Header>Rates</Card.Header>
      <Card.Body>
        <div>Rate Plan: {ratePlanName}</div>
        <div>Service Rate Plan: {serviceRatePlanName}</div>
      </Card.Body>
    </Card>
  );
};

export default Rates;
